import { setTestDriveAgreement as setTestDriveAgreementAction } from '@/context/display';
import { store } from '@/context/store';

export function setTestDriveAgreement(
    testDriveAgreement: string | null | undefined
): void {
    const testDriveAgreementState =
        store.getState().displayReducer.partner.testDriveAgreement;

    const agreement = testDriveAgreement;

    if (agreement && testDriveAgreementState !== agreement) {
        store.dispatch(setTestDriveAgreementAction(agreement));
    }
}
